import 'zone.js';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { PaymentTermsSelectorModule } from './payment-terms-selector/payment-terms-selector.module';

if (environment.production && !environment.prodEnabled) {
  enableProdMode();
  environment.prodEnabled = true;
}

platformBrowserDynamic().bootstrapModule(PaymentTermsSelectorModule)
  .catch((err) => console.error(err));
